import React from 'react';

import AlgoliaSearchBox from '../../../../components/AlgoliaSearchBox';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const LocationInfoHolder = createReactClass({
  getInitialState() {
    // filter on load for the case of loading in with initial location object
    let { states } = this.props;
    if (this.props.locationObject) {
      states = states.filter(
        function(state) {
          return state.country_id === this.props.locationObject.country || state.country === this.props.locationObject.country;
        }.bind(this)
      );
    }
    return {
      states,
      saveOrDeleteStatus: null
    };
  },
  componentDidMount() {
    this.didSwitchParentObject = false;
  },
  componentWillReceiveProps(newProps) {
    if (newProps.locationObject) {
      this.handleCountryChange(newProps.locationObject.country);
    }
    this.setState({ saveOrDeleteStatus: null });
  },
  componentDidUpdate() {
    // workarounds for React state squashing default values for text fields
    if (this.props.locationObject && (this.didSwitchParentObject || this.props.locationObject.name !== this.refs.name.value)) {
      if (this.refs.name !== undefined) {
        this.refs.name.value = this.props.locationObject.name;
      }
      if (this.props.locationObject.location) {
        this.refs.lat.value = this.props.locationObject.location.latitude;
        this.refs.lng.value = this.props.locationObject.location.longitude;
      } else {
        this.refs.lat.value = this.props.locationObject.latitude;
        this.refs.lng.value = this.props.locationObject.longitude;
      }
      this.didSwitchParentObject = false;
    }
    // set up PDF uploader if new selected object is a park
  },
  createInfoDiv(obj) {
    const name = Array.isArray(obj.name) ? obj.name[0] : obj.name;
    const countriesOptions = [];
    this.props.countries.forEach(function(item) {
      return <option>item.name</option>;
    });

    let nameEditDiv = null;
    if (obj.obj_type == 'countries') {
      nameEditDiv = <div className="edit-field display-only">Name: {name}</div>;
    } else {
      nameEditDiv = (
        <div className="edit-field">
          Name: <input className="edit-value" defaultValue={name} ref="name" />
        </div>
      );
    }

    let countriesSelect = null;
    if (obj.obj_type == 'cities' || obj.obj_type == 'parks') {
      const thisCountry = this.props.countries.filter(function(item, keyz) {
        if (item.id === obj.country) {
          return true;
        }
      });
      countriesSelect = <div className="edit-field">Country: {thisCountry[0].name}</div>;
    } else if (obj.country || obj.country_id) {
      countriesSelect = (
        <div className="edit-field">
          Country:
          <select onChange={this.handleCountrySelectChange} ref="country">
            {this.props.countries.map(function(item, keyz) {
              if (item.id === obj.country || item.id === obj.country_id) {
                return (
                  <option value={item.id} selected="selected">
                    {item.name}
                  </option>
                );
              }
              return <option value={item.id}>{item.name}</option>;
            })}
          </select>
        </div>
      );
    }
    let statesSelect = null;
    if (obj.obj_type == 'parks' || obj.obj_type == 'cities') {
      const statesOptions = this.state.states.map(function(state, keyz) {
        if (state.id === obj.state) {
          return (
            <option value={state.id} selected="selected">
              {state.name}
            </option>
          );
        }
        return <option value={state.id}>{state.name}</option>;
      });
      if (!obj.state) {
        statesOptions.unshift(
          <option value="" selected="selected">
            {' '}
            -{' '}
          </option>
        );
      } else {
        statesOptions.unshift(<option value=""> - </option>);
      }
      statesSelect = (
        <div className="edit-field">
          State:
          <select ref="state">{statesOptions}</select>
        </div>
      );
    }
    let cityDisplayDiv = null;
    if (obj.obj_type == 'parks' && (obj.type == null || obj.type == 'C')) {
      cityDisplayDiv = <div className="edit-field">City: {obj.city}</div>;
    }

    let parkTypeSelect = null;
    if (obj.obj_type == 'parks') {
      parkTypeSelect = (
        <div className="edit-field">
          Park Type:
          <select ref="park_type">
            {[
              <option value={null} selected={obj.type == null ? 'selected' : null}>
                {' '}
                -{' '}
              </option>,
              <option value="B" selected={obj.type == 'B' ? 'selected' : null}>
                Bureau of Land Management
              </option>,
              <option value="O" selected={obj.type == 'O' ? 'selected' : null}>
                County Park
              </option>,
              <option value="C" selected={obj.type == 'C' ? 'selected' : null}>
                Local Park
              </option>,
              <option value="F" selected={obj.type == 'F' ? 'selected' : null}>
                National Forest
              </option>,
              <option value="H" selected={obj.type == 'H' ? 'selected' : null}>
                National Historical Park
              </option>,
              <option value="I" selected={obj.type == 'I' ? 'selected' : null}>
                National Historical Site
              </option>,
              <option value="M" selected={obj.type == 'M' ? 'selected' : null}>
                National Monument
              </option>,
              <option value="N" selected={obj.type == 'N' ? 'selected' : null}>
                National Park
              </option>,
              <option value="P" selected={obj.type == 'P' ? 'selected' : null}>
                National Preserve
              </option>,
              <option value="A" selected={obj.type == 'A' ? 'selected' : null}>
                National Recreational Area
              </option>,
              <option value="E" selected={obj.type == 'E' ? 'selected' : null}>
                National Seashore
              </option>,
              <option value="W" selected={obj.type == 'W' ? 'selected' : null}>
                National Wilderness
              </option>,
              <option value="R" selected={obj.type == 'R' ? 'selected' : null}>
                Regional Park
              </option>,
              <option value="T" selected={obj.type == 'T' ? 'selected' : null}>
                State Forest
              </option>,
              <option value="V" selected={obj.type == 'V' ? 'selected' : null}>
                State Nature Reserve
              </option>,
              <option value="S" selected={obj.type == 'S' ? 'selected' : null}>
                State Park
              </option>
            ]}
          </select>
        </div>
      );
    }

    let latitudeDiv = null;
    let longitudeDiv = null;
    if (obj.location) {
      latitudeDiv = (
        <div className="edit-field">
          Latitude: <input className="edit-value" defaultValue={obj.location.latitude} ref="lat" />
        </div>
      );
      longitudeDiv = (
        <div className="edit-field">
          Longitude: <input className="edit-value" defaultValue={obj.location.longitude} ref="lng" />
        </div>
      );
    } else {
      latitudeDiv = (
        <div className="edit-field">
          Latitude: <input className="edit-value" defaultValue={obj.latitude} ref="lat" />
        </div>
      );
      longitudeDiv = (
        <div className="edit-field">
          Longitude: <input className="edit-value" defaultValue={obj.longitude} ref="lng" />
        </div>
      );
    }

    let category = '';
    if (obj.obj_type === 'parks') {
      category = 'Park';
    } else if (obj.obj_type === 'cities') {
      category = 'City';
    } else if (obj.obj_type === 'states') {
      category = 'State';
    } else {
      category = 'Country';
    }
    let locationLinkDiv = null;
    if (obj.url) {
      var url = `/${obj.url}`;
      locationLinkDiv = (
        <div className="edit-field display-only">
          <a href={url} target="_blank">
            {category} Page
          </a>
        </div>
      );
    } else if (obj.slug) {
      var url = `/${obj.slug}`;
      if (obj.obj_type === 'parks') {
        url = `/parks${url}`;
      }
      locationLinkDiv = (
        <div className="edit-field display-only">
          <a href={url} target="_blank">
            {category} Page
          </a>
        </div>
      );
    }

    return (
      <div>
        <h3>{name}</h3>
        <div className="compare-container-location">
          {locationLinkDiv}
          {nameEditDiv}
          {latitudeDiv}
          {longitudeDiv}
          {parkTypeSelect}
          {cityDisplayDiv}
          {statesSelect}
          {countriesSelect}
          <div className="edit-field display-only">
            <span>Popularity:</span>
            <span className="edit-value">{obj.popularity}</span>
          </div>
          <div className="edit-field display-only">
            <span>Trails:</span>
            <span className="edit-value">{obj.trails_count}</span>
          </div>
          {obj.reviews_count && (
            <div className="edit-field display-only">
              <span>Reviews:</span>
              <span className="edit-value">{obj.reviews_count}</span>
            </div>
          )}
          {obj.photos_count && (
            <div className="edit-field display-only">
              <span>Photos:</span>
              <span className="edit-value">{obj.photos_count}</span>
            </div>
          )}
          {obj.tracks_count && (
            <div className="edit-field display-only">
              <span>Activities:</span>
              <span className="edit-value">{obj.tracks_count}</span>
            </div>
          )}
        </div>
      </div>
    );
  },
  handleSelect(object) {
    this.props.handleObjectSelected(object, this.props.index);
    this.didSwitchParentObject = true;
  },
  handleCountrySelectChange(event) {
    this.handleCountryChange(parseInt(event.target.value));
  },
  handleCountryChange(newCountryId) {
    const statesByCountry = [];
    if (newCountryId) {
      this.props.states.forEach(function(item) {
        if (item.country_id === newCountryId || item.country === newCountryId) {
          statesByCountry.push(item);
        }
      });
    }
    this.setState({ states: statesByCountry });
  },
  handleDeletePark() {
    if (confirm(`Are you sure you want to delete ${this.props.locationObject.name}?  This cannot be undone.`)) {
      this.setState({ saveOrDeleteStatus: 'Deletion in progress' });

      this.props.performDelete(
        this.props.locationObject,
        {},
        function(success) {
          if (success) {
            this.setState({ saveOrDeleteStatus: 'Deletion complete' });
          } else {
            this.setState({ saveOrDeleteStatus: 'An error occurred' });
          }
        }.bind(this)
      );
    }
  },
  handleSave() {
    this.setState({ saveOrDeleteStatus: 'Saving in progress' });
    // make a deep copy of the location object to display changed attributes and stop React from rendering presave attrs
    const modifiedLocationObject = JSON.parse(JSON.stringify(this.props.locationObject));
    if (modifiedLocationObject.location) {
      modifiedLocationObject.location.latitude = parseFloat(this.refs.lat.value);
      modifiedLocationObject.location.longitude = parseFloat(this.refs.lng.value);
    } else {
      modifiedLocationObject.latitude = parseFloat(this.refs.lat.value);
      modifiedLocationObject.longitude = parseFloat(this.refs.lng.value);
    }

    const params = {
      latitude: this.refs.lat.value,
      longitude: this.refs.lng.value
    };
    if (this.refs.name !== undefined) {
      params.name = this.refs.name.value;
      modifiedLocationObject.name = this.refs.name.value;
    }
    if (this.refs.state !== undefined && this.refs.state.value !== null) {
      params.state_id = this.refs.state.value;
      modifiedLocationObject.state = parseInt(this.refs.state.value);
    }
    if (this.refs.country !== undefined) {
      params.country_id = this.refs.country.value;
      modifiedLocationObject.country = parseInt(this.refs.country.value);
    }
    if (this.refs.park_type !== undefined && this.refs.park_type.value !== '' && this.refs.park_type.value !== null) {
      params.type = this.refs.park_type.value;
      modifiedLocationObject.type = this.refs.park_type.value;
    }

    this.props.performSave(
      this.props.locationObject,
      modifiedLocationObject,
      params,
      this.props.index,
      function(success) {
        if (success) {
          this.setState({ saveOrDeleteStatus: 'Change queued for processing' });
        } else {
          this.setState({ saveOrDeleteStatus: 'An error occurred' });
        }
      }.bind(this)
    );
  },
  render() {
    let objectInfoBlock = null;
    let deleteButton = null;
    let saveButton = null;
    if (this.props.locationObject) {
      objectInfoBlock = this.createInfoDiv(this.props.locationObject);
      saveButton = (
        <div className="user-info-centered">
          <div className="btn green rounded simple" onClick={this.handleSave}>
            Save
          </div>
        </div>
      );
      if (this.props.locationObject.obj_type === 'parks') {
        deleteButton = (
          <div className="user-info-centered">
            <div className="btn orange rounded simple" onClick={this.handleDeletePark}>
              Delete
            </div>
          </div>
        );
      }
    }
    let statusText = null;
    if (this.state.saveOrDeleteStatus) {
      statusText = <div className="user-info-centered">{this.state.saveOrDeleteStatus}</div>;
    }
    const floatClass = this.props.left ? 'floatleft edit-container' : 'floatright edit-container';
    let labelText = '';
    let searchBoxPlaceholderText = 'Enter a city, state or park name...';
    if (this.props.allowedTypes.length === 2) {
      labelText = 'Enter City, State or Park';
    } else if (this.props.allowedTypes[0] === 'area') {
      labelText = 'Enter Park';
      searchBoxPlaceholderText = 'Enter a park name...';
    } else if (this.props.allowedTypes[0] === 'place') {
      labelText = 'Enter City or State';
      searchBoxPlaceholderText = 'Enter a city or state name...';
    }

    if (this.props.left) {
      labelText += ' to merge or edit';
    } else {
      labelText += ' to merge into';
    }

    return (
      <div className={floatClass}>
        <div className="edit-field">
          <label>{labelText}</label>
          <div className="search-holder">
            <AlgoliaSearchBox
              enterSelectsFirstMatch
              handleAreaSelect={this.handleSelect}
              handleLocationSelect={this.handleSelect}
              handleQueryStringSubmit={null}
              handleTrailSelect={null}
              noFollowHref
              numResults={10}
              placeholderText={searchBoxPlaceholderText}
              typeSubset={this.props.allowedTypes}
            />
          </div>
        </div>
        {objectInfoBlock}
        <div>
          {statusText}
          {saveButton}
          {deleteButton}
        </div>
      </div>
    );
  }
});

const LocationMergeInterface = createReactClass({
  getInitialState() {
    const countries = this.props.countries.map(function(item) {
      return item.country;
    });
    const states = this.props.states.map(function(item) {
      return item.state;
    });
    let object1 = null;
    let showReset = false;
    let showSecondEntryField = false;
    let allowedTypes = ['area', 'place'];
    if (this.props.initialPark) {
      object1 = this.props.initialPark;
      object1.obj_type = 'parks';
      allowedTypes = ['area'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialCity) {
      object1 = this.props.initialCity;
      object1.obj_type = 'cities';
      allowedTypes = ['place'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialState) {
      object1 = this.props.initialState;
      object1.obj_type = 'states';
      allowedTypes = ['place'];
      showReset = true;
      showSecondEntryField = true;
    } else if (this.props.initialCountry) {
      object1 = this.props.initialCountry;
      object1.obj_type = 'countries';
      allowedTypes = ['place'];
      showReset = true;
    }
    return {
      object1,
      object2: null,
      allowedTypes,
      showReset,
      showSecondEntryField,
      countries,
      states,
      mergeStatus: null
    };
  },
  containsCatchAllCity() {
    // cities with no name and a '-' slug are catch-alls for the geocoder for trails with no city and should not be merged in either direction
    if (
      (this.state.object2.slug === '-' && this.state.object2.name === null) ||
      (this.state.object1.slug === '-' && this.state.object1.name === null)
    ) {
      return true;
    }
    return false;
  },
  performMerge(e, force = false) {
    let url = '';
    const params = {};
    if (this.containsCatchAllCity()) {
      alert('This city cannot be merged.');
      return;
    }

    if (force || confirm(`Are you sure you want to merge ${this.state.object1.name} into ${this.state.object2.name}?`)) {
      if (force) {
        params.force_merge = force;
      }

      if (this.state.allowedTypes[0] === 'area') {
        url = `/api/alltrails/locations/parks/${this.state.object1.id}/merge`;
        params.park_id_to_merge_into = this.state.object2.id;
      } else if (this.state.allowedTypes[0] === 'place') {
        if (this.state.object1.obj_type == 'cities') {
          url = `/api/alltrails/locations/cities/${this.state.object1.id}/merge`;
          params.city_id_to_merge_into = this.state.object2.id;
        } else if (this.state.object1.obj_type == 'states') {
          url = `/api/alltrails/locations/states/${this.state.object1.id}/merge`;
          params.state_id_to_merge_into = this.state.object2.id;
        }
      }

      ServerCommunicationUtil.postApiEndpoint(
        url,
        params,
        function(data) {
          // prompt again if duplicate cities were found, and retry with force flag on confirmation
          if (data.duplicatedCities && data.duplicatedCities.length > 0) {
            const names = data.duplicatedCities
              .map(function(c) {
                return c.name;
              })
              .join(', ');
            if (
              confirm(
                `Found cities with the same name in both states, do you want to merge these? The following cities in ${this.state.object1.name} will be merged into their counterparts in ${this.state.object2.name}: ${names}.`
              )
            ) {
              this.performMerge(null, true);
            }
          } else {
            this.setState({ mergeStatus: 'Merge queued for processing' });
          }
        }.bind(this),
        function() {
          this.setState({ mergeStatus: 'An error occurred' });
        }.bind(this),
        function() {}
      );
    }
  },
  performSave(object, newLocationObject, params, objectIndex, callback) {
    if (objectIndex === 1) {
      this.setState({ object1: newLocationObject });
    } else {
      this.setState({ object2: newLocationObject });
    }
    ServerCommunicationUtil.putApiEndpoint(
      `/api/alltrails/locations/${object.obj_type}/${object.id}`,
      params,
      function(data) {
        callback(true);
      },
      function() {
        callback(false);
      },
      function() {}
    );
  },
  performDelete(object, params, callback) {
    ServerCommunicationUtil.deleteApiEndpoint(
      `/api/alltrails/locations/${object.obj_type}/${object.id}`,
      params,
      function(data) {
        callback(true);
      },
      function() {
        callback(false);
      },
      function() {}
    );
  },
  switchObjectOrder() {
    const allowedType = this.state.allowedTypes;
    const newObj1 = this.state.object2;
    const newObj2 = this.state.object1;
    this.resetFields();
    this.setState({
      object1: newObj1,
      object2: newObj2,
      showSecondEntryField: true,
      showReset: true,
      allowedTypes: allowedType
    });
  },
  isDuplicateObject(obj) {
    // compare ID's once we know both objects are of the same type (park, city, etc.)
    let isDuplicate = false;
    if (this.state.object1 && this.state.object1.id === obj.ID) {
      isDuplicate = true;
    } else if (this.state.object2 && this.state.object2.id === obj.ID) {
      isDuplicate = true;
    }
    return isDuplicate;
  },
  resetFields() {
    this.setState({
      object1: null,
      object2: null,
      allowedTypes: ['area', 'place'],
      showReset: false,
      mergeStatus: null,
      showSecondEntryField: false
    });
    return false;
  },
  handleObjectSelected(object, index) {
    // reject the Algolia result if user selects wrong kind of location to merge, or if the selection is the same result
    if (
      object.objectID.indexOf('area') === -1 &&
      object.objectID.indexOf('cityo') === -1 &&
      object.objectID.indexOf('state') === -1 &&
      this.state.object1 &&
      index === 2
    ) {
      alert('Please select a city, state or park.');
      return false;
    }
    if (this.isDuplicateObject(object)) {
      alert('Please select two different locations.');
      return false;
    }
    // Don't let a city be merged into a state and vice versa
    if (this.state.object1 && index === 2) {
      if (this.state.object1.obj_type == 'cities' && object.objectID.indexOf('cityo') === -1) {
        alert('Please select a city.');
        return false;
      }
      if (this.state.object1.obj_type == 'states') {
        if (object.objectID.indexOf('state') === -1) {
          alert('Please select a state.');
          return false;
        }
        // url is the only thing present on both objects that has country in consistent format
        if (this.state.object1.url.split('/')[0] != object.slug.split('/')[0]) {
          alert('Please select a state in the same country.');
          return false;
        }
      }
    }

    const { type } = object;
    if (type === 'area') {
      ServerCommunicationUtil.getApiEndpoint(
        '/api/alltrails/locations/parks/',
        { park_id: object.ID },
        function(data) {
          data[0].obj_type = 'parks';
          if (index === 1) {
            this.setState({
              object1: data[0],
              allowedTypes: [type],
              showReset: true,
              mergeStatus: null,
              showSecondEntryField: true
            });
          } else {
            this.setState({ object2: data[0] });
          }
        }.bind(this),
        function() {
          console.log('error');
        },
        function() {}
      );
    } else {
      // if Algolia type is 'place' we need to parse whether the result is a city/state/country
      if (object.objectID.indexOf('state') !== -1) {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/states',
          { state_id: object.ID },
          function(data) {
            data[0].obj_type = 'states';
            if (index === 1) {
              this.setState({
                object1: data[0],
                showReset: true,
                showSecondEntryField: true,
                allowedTypes: [type]
              });
            } else {
              this.setState({ object2: data[0] });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      } else if (object.objectID.indexOf('country') !== -1) {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/countries',
          { country_id: object.objectID.split('-')[1] },
          function(data) {
            data[0].obj_type = 'countries';
            if (index === 1) {
              this.setState({
                object1: data[0],
                showReset: true,
                allowedTypes: [type]
              });
            } else {
              this.setState({ object2: data[0] });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      } else {
        ServerCommunicationUtil.getApiEndpoint(
          '/api/alltrails/locations/cities/',
          { city_id: object.ID },
          function(data) {
            data[0].obj_type = 'cities';
            if (index === 1) {
              var cityNotMergable = data[0].slug === '-' && (data[0].name === null || data[0].name === undefined);
              var mergingStatus = cityNotMergable ? 'This city cannot be merged' : null;
              this.setState({
                object1: data[0],
                allowedTypes: [type],
                showReset: true,
                mergeStatus: mergingStatus,
                showSecondEntryField: true
              });
            } else {
              var cityNotMergable = data[0].slug === '-' && (data[0].name === null || data[0].name === undefined);
              var mergingStatus = cityNotMergable ? 'This city cannot be merged' : null;
              this.setState({
                object2: data[0],
                mergeStatus: mergingStatus
              });
            }
          }.bind(this),
          function() {
            console.log('error');
          },
          function() {}
        );
      }
    }

    event.preventDefault();
    return false;
  },
  render() {
    let secondLocationHolder = null;
    if (this.state.showSecondEntryField) {
      secondLocationHolder = (
        <LocationInfoHolder
          locationObject={this.state.object2}
          handleObjectSelected={this.handleObjectSelected}
          left={false}
          index={2}
          allowedTypes={this.state.allowedTypes}
          countries={this.state.countries}
          states={this.state.states}
          type={this.state.allowedTypes[0]}
          performSave={this.performSave}
          performDelete={this.performDelete}
        />
      );
    }
    let mergeButton = null;
    if (this.state.object1 !== null && this.state.object2 !== null) {
      if (this.state.mergeStatus !== null) {
        mergeButton = (
          <div className="user-info-centered" disabled>
            <div className="btn grey rounded simple" onClick={this.performMerge}>
              MERGE
            </div>
          </div>
        );
      } else {
        mergeButton = (
          <div className="user-info-centered">
            <div className="btn blue rounded simple" onClick={this.performMerge}>
              MERGE
            </div>
          </div>
        );
      }
    }

    let mergeText = null;
    if (this.state.mergeStatus) {
      mergeText = <div className="user-info-centered">{this.state.mergeStatus}</div>;
    }

    let swapButton = null;
    if (this.state.object1 !== null && this.state.object2 !== null) {
      swapButton = (
        <div className="user-info-centered">
          <div className="btn green rounded simple" onClick={this.switchObjectOrder}>
            Switch Order
          </div>
        </div>
      );
    }

    let resetButton = null;
    if (this.state.showReset) {
      resetButton = (
        <div className="user-info-centered">
          <div className="btn brown rounded simple" onClick={this.resetFields}>
            Reset
          </div>
        </div>
      );
    }

    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="field clear contains-separator">
            <LocationInfoHolder
              locationObject={this.state.object1}
              handleObjectSelected={this.handleObjectSelected}
              left
              index={1}
              allowedTypes={this.state.allowedTypes}
              countries={this.state.countries}
              states={this.state.states}
              type={this.state.allowedTypes[0]}
              performSave={this.performSave}
              performDelete={this.performDelete}
            />
            {secondLocationHolder}
          </div>
          {resetButton}
          {swapButton}
          {mergeText}
          {mergeButton}
        </div>
      </div>
    );
  }
});

export { LocationMergeInterface };
